import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ContentNotEnoughQuantityError extends CodedError {
  static get errorName() {
    return errorCodes.contentNotEnoughQuantity.code;
  }

  constructor(message: string = errorCodes.contentNotEnoughQuantity.message) {
    super(message);
    this.code = errorCodes.contentNotEnoughQuantity.code;
    this.message = `${message} ${errorCodes.contentNotEnoughQuantity.code}`;
    this.name = errorCodes.contentNotEnoughQuantity.name;
  }
}
